import { Pipe, PipeTransform } from "@angular/core";
import { CachedFile, SyncAction } from "../../shared/types";
import { AppEvent } from "@intocare-medapp/events/event.model";

@Pipe({
	name: "actionType",
	standalone: false,
})
export class ActionTypePipe implements PipeTransform {
	transform(item: SyncAction | CachedFile | AppEvent): "file" | "action" | "event" {
		if ("filename" in item) {
			return "file";
		}

		if ("method" in item) {
			return "action";
		}

		return "event";
	}
}
